import React from "react";

function SpurTypeCell({ value }) {
  return (
    <span className="pg-chip pg-chip--spur-type" title={value} aria-label={`Spur type ${value}`}>
      {value}
    </span>
  );
}

export default SpurTypeCell;
